export default (api) => ({
    get: ({ reportId, type }) => api.get(`/reports/${reportId}/${type}`),
})
